import React, { useState } from 'react';

const styles = {
    button: {
        background: 'transparent', border: 'none', padding: '0 0 0 6px', cursor: 'pointer',
        color: '#818FA5', fontSize: 13, lineHeight: 1, verticalAlign: 'middle',
    },
};

/**
* Small inline "copy to clipboard" button (VD-725): request IDs, DB query
* payloads, fingerprints, body hashes - anywhere a value is meant to be
* pasted into a support ticket rather than read character by character.
* Falls back to execCommand since navigator.clipboard needs a secure context,
* which a plain-http deployment of this dashboard may not have.
*/
function CopyButton({ lang, value, label }) {
    let [copied, setCopied] = useState(false);

    let copy = (e) => {
        e.stopPropagation();

        if (!value) {
            return;
        }

        let done = () => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(value).then(done, () => {
                fallbackCopy(value);
                done();
            });
        } else {
            fallbackCopy(value);
            done();
        }
    };

    return (
        <button type="button" style={styles.button} onClick={copy} aria-label={(label || 'Copy').translate(lang)} title={(label || 'Copy').translate(lang)}>
            {copied ? '✓' : '⧉'}
        </button>
    );
}

function fallbackCopy(value) {
    let input = document.createElement('textarea');
    input.value = value;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    try { document.execCommand('copy'); } catch (e) { /* no-op, nothing more we can do */ }
    document.body.removeChild(input);
}

export default CopyButton;
